import { type QueryParams, type SortBy } from "./typed";

interface SortByMapperProps {
  sortByItems: {
    label: string;
    value: string;
    slug: string;
  }[];
}

const sortByMapper = (props: SortByMapperProps) => {
  const { sortByItems } = props;

  return {
    createURL: (sortBy: SortBy): QueryParams => {
      const queryParams: QueryParams = {};

      if (!sortBy) {
        return queryParams;
      }

      // generate mapper
      const sortByMap: Record<string, string> = {};
      sortByItems.forEach((s) => {
        sortByMap[s.value] = s.slug;
      });

      const queryParamsVal = sortByMap[sortBy];
      if (queryParamsVal) {
        queryParams["sort-by"] = queryParamsVal;
      }

      return queryParams;
    },
    parseURL: (queryParams: QueryParams): SortBy => {
      const queryParamsSortBy = queryParams["sort-by"];

      if (!queryParamsSortBy) {
        return undefined;
      }

      // generate mapper
      const sortByMap: Record<string, string> = {};
      sortByItems.forEach((s) => {
        sortByMap[s.slug] = s.value;
      });

      if (queryParamsSortBy && typeof queryParamsSortBy === "string") {
        return sortByMap[queryParamsSortBy];
      }

      return undefined;
    },
  };
};

export {
  sortByMapper,
};
